import { cn } from '@/lib/utils';

type Theme = 'LIGHT' | 'DARK';

interface PoweredByLogoProps {
  theme?: Theme;
  fontFamily?: string;
  classNameText?: string;
  classNameLogo?: string;
  isModeratorLive?: boolean;
  isNotLivePage?: boolean;
  displayItemsOnModeratorLive?: boolean;
}

export function PoweredByLogo({
  theme,
  fontFamily,
  classNameText,
  classNameLogo,
  isModeratorLive,
  isNotLivePage,
  displayItemsOnModeratorLive,
}: PoweredByLogoProps) {
  const textColor = theme === 'LIGHT' ? '#9E9FA6' : '#FFFFFF';
  const logoSrc = theme === 'LIGHT' ? '/assets/logo-black.svg' : '/assets/logo-white.svg';

  return (
    <div
      className={cn(
        `flex ${isNotLivePage ? 'flex-row' : 'flex-col xl:flex-row'} items-start 2xl:items-center  gap-2`,
        isModeratorLive &&
          `flex-col! items-start! ${displayItemsOnModeratorLive ? '4xl:items-center! 4xl:flex-row!' : ''}`,
      )}
    >
      <p
        className={cn('text-white font-medium', classNameText)}
        style={{
          fontFamily: fontFamily || 'Poppins',
          color: textColor,
        }}
      >
        Powered by
      </p>
      <img src={logoSrc} alt="logo" width={100} height={100} className={classNameLogo} />
    </div>
  );
}
